import { get, post, put, del } from './client';

export const listarCandidatos = () => get('/candidatos');
export const criarCandidato = (payload) => post('/candidatos', payload);
export const atualizarCandidato = (id, payload) => put(`/candidatos/${id}`, payload);
export const removerCandidato = (id) => del(`/candidatos/${id}`);
